import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Grid } from "../../core/components/grid";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { Config } from "../../core/config/config";
import { EditTicketLevel } from "./editTicketLevel";
import { General } from "../../../siteManagement/general";
import { SheetEventType } from "../../../siteManagement/sheet";
import { Helper } from "../../core/util/helper";
import LevelApp, { LevelEntity, LevelAppProps } from "../level/level";
import AgreementApp, { AgreementEntity, AgreementAppProps, ActionRight, AgreementLevelEntity } from "../agreement/agreement"
import { EntityTicket } from "../../ticket/ticket";
import { Context, Metadata } from "../../core/components/commonApp";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react";
export default class TicketLevelGrid extends React.Component<TicketLevelGridProps, TicketLevelGridState>{
    private _translations: StringKeyDictionary<string>;
    private _dataUrl: string;
    private _selectedItem: TicketLevel;

    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        open: true,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {
                }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this._save();
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false });
        },
        width: 800
    };

    constructor(props: TicketLevelGridProps) {
        super(props);
        this._translations = props.translations;
        this._dataUrl = "SlaTicketLevel/GetTicketLevelData?ticketId=" + props.entity.ProblemNr;
        this.state = { dialogOpen: false };
    }

    private _getGridData() {
        HTTPService.get(this._dataUrl)
            .then((result: JsonResultClass) => {
                if (result.Code === 0) {
                    this.setState({ gridData: result.Data });
                }
                else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            }, (error) => {
                console.error(error);
            });
    }

    private _save = () => {
        const url = "SlaTicketLevel/SaveTicketLevel";
        if (this._selectedItem != null) {
            HTTPService.post<JsonResultClass>(url, this._selectedItem).then(result => {
                if (result.Code === 0) {
                    NotificationHelper.showSuccessMessage(result.Message);
                    this._getGridData();
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
        }
    }

    private _getAgreedTargetDate = () => {
        let agreedTargetDate = this._selectedItem != null ?
            (typeof this._selectedItem.AgreedTargetOnLocal === "string" ? kendo.parseDate(this._selectedItem.AgreedTargetOnLocal) : this._selectedItem.AgreedTargetOnLocal)
            : null;
        return agreedTargetDate;
    }

    private _openLevel = (id: string) => {
        let entityURL = "SlaLevel/GetByTicketLevel?id=" + id;
        HTTPService.chainBatch
            .add<JsonResultClass<LevelEntity>>(entityURL)
            .add<Metadata>(Helper.getMetaData("slaLevel"))
            .promise()
            .then(result => {
                const entity = result[0].Data;
                const metadata = result[1];
                const props: LevelAppProps = {
                    context: { },
                    title: "level",
                    entity: entity,
                    metadata: metadata,
                    dataSources: {},
                    isWindow: false
                }

                const sheet = General.Sheet.Manager.createSheet();
                sheet.bind(SheetEventType.Close, (target) => {
                    this._getGridData();
                });

                sheet.show(() => {
                    sheet.mountContent(LevelApp, props);
                });
            });
    }

    private _openAgreement = (id: string, agreementId: string) => {
        let entityURL = "SlaAgreement/GetByTicketLevel?id=" + id;
        HTTPService.chainBatch
            .add<JsonResultClass<AgreementEntity>>(entityURL)
            .add<Metadata>(Helper.getMetaData("slaAgreement"))
            .add<JsonResultClass<ActionRight[]>>('SlaAgreement/GetRights/?id=' + encodeURIComponent(agreementId))
            .promise()
            .then(result => {
                const entity = result[0].Data;
                const metadata = result[1];
                const props: AgreementAppProps = {
                    context: {
                        translations: null
                    },
                    title: "Agreement",
                    entity: entity,
                    metadata: metadata,
                    dataSources: {},
                    isWindow: false,
                    actionRights: result[2].Data
                }

                const sheet = General.Sheet.Manager.createSheet();
                sheet.bind(SheetEventType.Close, (target) => {
                    this._getGridData();
                });

                sheet.show(() => {
                    sheet.mountContent(AgreementApp, props);
                });
            });
    }

    //JSX
    private _createGrid = () => {
        let editButtonEnabled = (this.props.entity.Stufe > 1 && this.props.entity.RecordRight.CanWrite);

        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: this._translations["Standard.Editieren"], enabled: editButtonEnabled });

        const customButtons: Array<GridCustomToolBarButton> = [];
        customButtons.push({ caption: this._translations["WebSMS.SLA.TicketLevel.GoToLevel"], enabled: true, iconClass: "fal fa-clipboard-list-check", id: "GoToLevel", autoEnabledOnRecordSelected: true, useContextMenu: true });
        customButtons.push({ caption: this._translations["WebSMS.SLA.TicketLevel.GoToAgreement"], enabled: true, iconClass: "fal fa-clipboard-list-check", id: "GoToAgreement", autoEnabledOnRecordSelected: true, useContextMenu: true });

        return this.state.gridData != null ?
            <Grid
                data={this.state.gridData}
                options={this.props.context.ticketLevelGrid}
                id="ticketLevel"
                standardButtons={standardButtons}
                onClickStandardButton={this.handleClickStandardButton}
                customButtons={customButtons}
                onClickCustomButton={this.handleCustomButton}
                gridDetails={{
                    useFeature: true
                }}
                useFloatingButtons={true}
            /> : null;
    }

    handleCustomButton = (id: string, dataItem: TicketLevel) => {
        switch (id) {
            case ("GoToLevel"):
                this._openLevel(dataItem.Id);
                break;
            case ("GoToAgreement"):
                this._openAgreement(dataItem.Id, dataItem.AgreementId);
                break;

        }

    }

    handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: any) => {
        if (type === ToolBarStandardButtonType.EDIT) {
            this._selectedItem = dataItem;
            this.setState({ dialogOpen: true });
        }
    }

    onAgreedTargetDateChanged = (field: { model: string }, value: any, dataItem?: any) => {
        this._selectedItem.AgreedTargetOnLocal = value;
    }

    onAgreedTargetCommentChanged = (field: { model: string }, value: any, dataItem?: any) => {
        this._selectedItem.AgreedTargetComment = value;
    }

    componentDidMount() {
        this._getGridData();
        const sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.bind(SheetEventType.Custom, eventInfo => {
            if (eventInfo != null && eventInfo.event === "Reloading") {
                this._getGridData();
            }
        })
    }

    render() {
        return (<>
            {this._createGrid()}
            {this.state.dialogOpen ?
                <Dialog {...this._dialogProps}>
                    <EditTicketLevel onAgreedTargetDateChanged={this.onAgreedTargetDateChanged} onAgreedTargetCommentChanged={this.onAgreedTargetCommentChanged}
                        translations={this._translations} agreedTargetDate={this._getAgreedTargetDate()}
                        agreedTargetComment={this._selectedItem ? this._selectedItem.AgreedTargetComment : null}></EditTicketLevel>
                </Dialog> : null}
        </>
        );
    }
}

interface TicketLevelGridProps {
    entity: EntityTicket;
    translations: StringKeyDictionary<string>;
    context: TicketLevelGridContext;
}

interface TicketLevelGridState {
    gridData?: Array<TicketLevel>;
    dialogOpen: boolean;
    selectedItemId?: string;
}

interface TicketLevelGridContext extends Context {
    ticketLevelGrid: object;
}

export interface TicketLevel {
    Id: string;
    TicketId: number;
    AgreementLevel: AgreementLevelEntity;
    AgreementId: string;
    AgreementLevelId: string;
    StartOnLocal?: Date | string;
    AgreedTargetOnLocal?: Date | string;
    TargetOnLocal?: Date | string;
    CompletionOnLocal?: Date | string;
    AgreedTargetComment?: string;
}